import { useState, useEffect } from "react";
// Наш хук
const useDebounceValue = (value, delay) => {
    const [debouncedValue, setDebouncedValue] = useState(value);
    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);
        return () => {
            clearTimeout(handler);
        };
    }, [value]);
    return debouncedValue;
};
export default useDebounceValue;
//# sourceMappingURL=useDebounceValue.js.map